<div class="container" [ngSwitch]="mode">
  <div *ngIf="viewAll">
    <app-template [title]="'Refund Amount'" style="padding-bottom: 400px">
      <div class="search" style="padding-top: 30px">
        <span class="form">
          <mat-form-field class="input">
            <mat-label>Start Date</mat-label>
            <input
              [(ngModel)]="sd"
              matInput
              [matDatepicker]="dob"
              (dateChange)="startDateChange($event)"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="dob"
            ></mat-datepicker-toggle>
            <mat-datepicker #dob></mat-datepicker>
          </mat-form-field>
        </span>
        <span class="form">
          <mat-form-field class="input">
            <mat-label>End Date</mat-label>
            <input
              [(ngModel)]="ed"
              matInput
              [matDatepicker]="end"
              (dateChange)="endDateChange($event)"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="end"
            ></mat-datepicker-toggle>
            <mat-datepicker #end></mat-datepicker>
          </mat-form-field>
        </span>

        <span class="input">
          <mat-form-field>
            <mat-label>Name</mat-label>
            <input [(ngModel)]="nameSearch" matInput placeholder="" />
          </mat-form-field>
        </span>

        <div>
          <button
            (click)="getPayments()"
            style="margin-bottom: 30px; margin-left: 30px; margin-top: 20px"
            mat-raised-button
            color="primary"
          >
            Search
          </button>
        </div>
      </div>
      <div class="data" style="padding-bottom: 400px">
        <div *ngIf="isLoading" style="margin-top: 200px" class="spinner">
          <mat-spinner></mat-spinner>
        </div>
        <table *ngIf="!isLoading" style="width: 100%">
          <tr class="back">
            <th>Lab ID</th>
            <th>Receipt Date</th>
            <th>Name</th>
            <th>Billed Amount</th>
            <th>Amount Paid</th>
            <th></th>
          </tr>
          <tr
            class="td"
            *ngFor="let item of encounters"
            style="cursor: pointer"
          >
            <td>{{ item.bill_id }}</td>
            <td>
              <div>{{ item.receipt_date | date }}</div>
            </td>
            <td>{{ item.patient_first_name }}</td>
            <td>{{ item.bill_amount | currency : "&#8358;" }}</td>
            <td>{{ item.amount_paid | currency : "&#8358;" }}</td>
            <td>
              <div class="dropdown">
                <button class="dropbtn" mat-raised-button>Actions</button>
                <div class="dropdown-content">
                  <!-- <a class="dropdown-item" (click)="addRecord(item)">Select</a>
                  <a class="dropdown-item" (click)="editBill(item)">Edit</a> -->
                  <a class="dropdown-item" (click)="view(item)">View</a>
                  <a class="dropdown-item" (click)="print()">Print</a>
                </div>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </app-template>
  </div>

  <div class="bottom" *ngIf="!viewAll">
    <button
      (click)="back()"
      mat-raised-button
      color="primary"
      style="margin: 20px"
    >
      Back
    </button>
    <button
      (click)="refundAll()"
      mat-raised-button
      color="primary"
      style="margin: 20px"
    >
      Refund All
    </button>
    <div class="item" style="padding: 0 20px">
      <table style="width: 100%">
        <tr class="back">
          <th>Name</th>
          <th>Price</th>
          <th>Dept</th>
          <th>Sub Dept</th>
          <th>Status</th>
          <th></th>
        </tr>
        <tr
          class="td"
          *ngFor="let item of listOfService"
          style="cursor: pointer"
          [ngClass]="{ inActive: item.status === 'InActive' }"
        >
          <td>{{ item.service_name }}</td>
          <td>{{ item.net_amount | currency : "&#8358;" }}</td>
          <td>{{ item.dept_name }}</td>
          <td>{{ item.sub_dept_name }}</td>
          <td>{{ item?.status || "Active" }}</td>
          <td>
            <button (click)="refund(item)" mat-raised-button color="primary">
              Refund
            </button>
          </td>
        </tr>
      </table>
    </div>
  </div>
</div>
